import React, { useState, useEffect } from 'react';
import { FaTimes, FaPaperPlane, FaCheck, FaStar, FaUser, FaEnvelope, FaPhone, FaComment, FaShieldAlt } from 'react-icons/fa';
import { MdVerified } from 'react-icons/md';
import { api } from '../lib/api';

const EnquiryPopup = () => {
  const [isOpen, setIsOpen] = useState(true);
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
    agreeTerms: false,
    receiveUpdates: false
  });
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.fullName || !formData.email || !formData.phone || !formData.subject || !formData.agreeTerms) {
      alert("Please fill all required fields");
      return;
    }

    try {
      await api.submitEnquiry({
        fullName: formData.fullName,
        email: formData.email,
        phone: formData.phone,
        subject: formData.subject,
        message: formData.message,
        agreeTerms: formData.agreeTerms,
        receiveUpdates: formData.receiveUpdates,
        source: "popup"
      });
      setIsSubmitted(true);
      setTimeout(() => {
        setIsSubmitted(false);
        setIsOpen(false);
        document.body.style.overflow = 'auto';
      }, 2000);
    } catch (error) {
      console.error("Error:", error);
      alert("Failed to send enquiry ❌");
    }
  };

  const handleClose = () => {
    setIsOpen(false);
    document.body.style.overflow = 'auto';
  };

  if (!isOpen) return null;

  return (
    <>
      <div 
        className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-center justify-center"
        onClick={handleClose}
      >
        <div 
          className="relative rounded-xl shadow-2xl w-full max-w-sm mx-4 overflow-hidden"
          style={{ backgroundColor: '#ffffff' }}
          onClick={(e) => e.stopPropagation()}
        >
          <div style={{ background: 'linear-gradient(135deg, #800000 0%, #4a0000 100%)' }} className="px-4 py-3">
            <div className="flex justify-between items-center">
              <div className="flex-1">
                <div className="flex items-center gap-1.5 mb-0.5">
                  <FaStar style={{ color: '#FFD700' }} className="text-xs" />
                  <h2 className="text-sm font-bold" style={{ color: '#FFD700' }}>St. Xavier's School</h2>
                </div>
                <p style={{ color: '#FFD700' }} className="text-[10px] opacity-80">Quick Enquiry Form</p>
              </div>
              <button 
                onClick={handleClose}
                className="hover:bg-white/20 p-1.5 rounded-full transition-colors"
                style={{ color: '#FFD700' }}
              >
                <FaTimes className="text-sm" />
              </button>
            </div>
          </div>
          {isSubmitted && (
            <div className="m-3 bg-green-50 border border-green-200 rounded-lg p-2 flex items-center gap-2">
              <div className="bg-green-500 rounded-full p-0.5">
                <FaCheck className="text-white text-[8px]" />
              </div>
              <p className="text-xs font-semibold text-green-800">Sent Successfully!</p>
            </div>
          )}
          <form onSubmit={handleSubmit} className="p-4 space-y-2.5">
            {/* Name */}
            <div>
              <label className="block font-semibold text-[11px] mb-1" style={{ color: '#800000' }}>
                Full Name <span style={{ color: '#FF0000' }}>*</span>
              </label>
              <div className="relative">
                <FaUser className="absolute left-2.5 top-1/2 -translate-y-1/2 text-[10px]" style={{ color: '#800000' }} />
                <input
                  type="text"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  required
                  className="w-full pl-7 pr-2 py-1.5 text-xs border rounded-lg focus:outline-none focus:ring-1"
                  style={{ borderColor: '#800000', focusBorderColor: '#FFD700' }}
                  placeholder="Enter your name"
                />
              </div>
            </div>
            <div>
              <label className="block font-semibold text-[11px] mb-1" style={{ color: '#800000' }}>
                Email <span style={{ color: '#FF0000' }}>*</span>
              </label>
              <div className="relative">
                <FaEnvelope className="absolute left-2.5 top-1/2 -translate-y-1/2 text-[10px]" style={{ color: '#800000' }} />
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full pl-7 pr-2 py-1.5 text-xs border rounded-lg focus:outline-none focus:ring-1"
                  style={{ borderColor: '#800000' }}
                  placeholder="your@email.com"
                />
              </div>
            </div>
            <div>
              <label className="block font-semibold text-[11px] mb-1" style={{ color: '#800000' }}>
                Phone <span style={{ color: '#FF0000' }}>*</span>
              </label>
              <div className="relative">
                <FaPhone className="absolute left-2.5 top-1/2 -translate-y-1/2 text-[10px]" style={{ color: '#800000' }} />
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  className="w-full pl-7 pr-2 py-1.5 text-xs border rounded-lg focus:outline-none focus:ring-1"
                  style={{ borderColor: '#800000' }}
                  placeholder="10-digit mobile"
                />
              </div>
            </div>
            <div>
              <label className="block font-semibold text-[11px] mb-1" style={{ color: '#800000' }}>
                Subject <span style={{ color: '#FF0000' }}>*</span>
              </label>
              <select
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                required
                className="w-full px-2 py-1.5 text-xs border rounded-lg focus:outline-none focus:ring-1 bg-white"
                style={{ borderColor: '#800000' }}
              >
                <option value="">Select</option>
                <option value="admission">Admission Inquiry</option>
                <option value="fee">Fee Structure</option>
                <option value="facility">School Facilities</option>
                <option value="other">Other</option>
              </select>
            </div>
            <div>
              <label className="block font-semibold text-[11px] mb-1" style={{ color: '#800000' }}>
                Message
              </label>
              <div className="relative">
                <FaComment className="absolute left-2.5 top-2 text-[10px]" style={{ color: '#800000' }} />
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="2"
                  className="w-full pl-7 pr-2 py-1.5 text-xs border rounded-lg focus:outline-none focus:ring-1 resize-none"
                  style={{ borderColor: '#800000' }}
                  placeholder="Your message..."
                ></textarea>
              </div>
            </div>
            <div className="space-y-2">
              <label className="flex items-start gap-1.5 cursor-pointer">
                <input
                  type="checkbox"
                  name="agreeTerms"
                  checked={formData.agreeTerms}
                  onChange={handleChange}
                  required
                  className="mt-0.5 w-3 h-3 rounded"
                  style={{ accentColor: '#800000' }}
                />
                <span className="text-[9px] text-gray-600 leading-tight">
                  I agree to <a href="/terms" style={{ color: '#800000' }}>Terms</a> & <a href="/privacy-policy" style={{ color: '#800000' }}>Privacy</a>
                </span>
              </label>
              <label className="flex items-start gap-1.5 cursor-pointer">
                <input
                  type="checkbox"
                  name="receiveUpdates"
                  checked={formData.receiveUpdates}
                  onChange={handleChange}
                  className="mt-0.5 w-3 h-3 rounded"
                  style={{ accentColor: '#800000' }}
                />
                <span className="text-[9px] text-gray-500 leading-tight">
                  Receive updates via WhatsApp & SMS
                </span>
              </label>
            </div>
            <button
              type="submit"
              className="w-full font-semibold py-2 rounded-lg transition-all duration-300 flex items-center justify-center gap-1.5 text-xs"
              style={{ background: 'linear-gradient(135deg, #800000 0%, #4a0000 100%)', color: '#FFD700' }}
            >
              <FaPaperPlane style={{ color: '#FFD700' }} className="text-[10px]" />
              SEND ENQUIRY
            </button>
            <div className="text-center pt-0.5">
              <div className="flex items-center justify-center gap-1">
                <FaShieldAlt className="text-gray-400 text-[8px]" />
                <p className="text-[8px] text-gray-400">Secure & Confidential</p>
                <MdVerified style={{ color: '#FFD700' }} className="text-[10px]" />
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default EnquiryPopup;